import logo from '../assets/bekebi-logo.png';

/**
 * The official Bekebi logo (the supplied file, unchanged: apps/web/src/assets/bekebi-logo.png,
 * 512 × 512, transparent background). Shown at a square size with its proportions kept; it is
 * decorative next to the "Bekebi Portal" name, so it carries no alternative text of its own.
 */
export function BekebiMark({ size = 28 }: { size?: number }) {
  return (
    <img
      src={logo}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      draggable={false}
      className="shrink-0 select-none object-contain"
    />
  );
}

export function BekebiWordmark({ view }: { view?: string }) {
  return (
    <span className="flex min-w-0 items-center gap-2.5">
      <BekebiMark size={30} />
      <span className="flex min-w-0 items-baseline gap-2">
        <span className="whitespace-nowrap text-[0.95rem] font-semibold tracking-tight text-fg">
          Bekebi Portal
        </span>
        {view ? (
          <span className="hidden rounded-md bg-raised px-1.5 py-0.5 text-[0.7rem] font-semibold uppercase tracking-wide text-muted sm:inline">
            {view}
          </span>
        ) : null}
      </span>
    </span>
  );
}
